import { FC, ReactNode } from 'react'
import { IconPaths, KTSVG } from '../../../_metronic/helpers'

type IInfoContainer = {
  children: ReactNode
  className?: string
  isWarning?: boolean
}

export const InfoContainer: FC<IInfoContainer> = ({ children, className = '', isWarning }) => (
  <div
    className={`d-flex align-items-center p-5 rounded ${
      isWarning ? 'bg-danger text-white' : 'bg-info-light'
    }  ${className}`}
  >
    <KTSVG path={IconPaths.Info} color={isWarning ? 'white' : 'blue'} className='svg-icon-1 me-2' />
    <span className='fs-6'>{children}</span>
  </div>
)
